import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=3c244ee2&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=ts"
export * from "./BetaBadge.vue?vue&type=script&lang=ts"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=3c244ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c244ee2",
  null
  
)

export default component.exports